import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoPrimeiraViaExameDeOrdemConfig = {
  id: 'pedido_PrimeiraViaExameDeOrdem',
  nome: 'Pedido de 1ª Via do Exame De Ordem',
  categoria: 'pedidos',
  descricao: 'Solicitação da 1ª Via do Exame De Ordem OAB/MS',
  icon: 'FaTrashAlt',

  documentConfig: {
    required: [
      { 
        id: 'requerimento', tipoDocumentoProcesso: 433, 
        name: 'Requerimento', 
        description: 'Requerimento preenchido e assinado digitalmente', 
        required: true 
      },
      { 
        id: 'copiaDigitalizadoCPF', tipoDocumentoProcesso: 510,
        name: 'Copia Digitalizado do CPF', 
        description: 'Copia Digitalizado do CPF', 
        required: true 
      },
      { 
        id: 'copiaDigitalizadoRG', tipoDocumentoProcesso: 533,
        name: 'Copia Digitalizado do RG', 
        description: 'Copia Digitalizado do RG', 
        required: true 
      },
      { 
        id: 'copiaDigitalizadoTituloEleitor', tipoDocumentoProcesso: 511,
        name: 'Copia Digitalizado do Título de Eleitor', 
        description: 'Copia Digitalizado do Título de Eleitor', 
        required: true 
      }
    ],

    conditional: [
      {
        id: 'diplomaGraduacao', tipoDocumentoProcesso: 317,
        name: 'Diploma de Graduação/Certificado de conclusão de Curso',
        description: 'Diploma de Graduação ou Certificado de conclusão de Curso (obrigatório para Bacharéis)',
        conditional: true,
        required: true,
        dependsOn: { field: 'situacaoAcademica', value: 'Bacharel' }
      },
      {
        id: 'atestadoMatricula', tipoDocumentoProcesso: 316,
        name: 'Atestado de Matrícula do semestre cursando no ato da inscrição',
        description: 'Atestado de Matrícula do semestre cursando no ato da inscrição (obrigatório para Cursando)',
        conditional: true,
        required: true,
        dependsOn: { field: 'situacaoAcademica', value: 'Cursando' }
      }
    ]
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: {
      field: 'situacaoAcademica',
      map: { Bacharel: '235', Cursando: '213' }
    },
    tiposAssunto: '626',
    tipoPedido: '360'
  },

  // Confirmado ao vivo contra GET /modelo-requerimento/{235,213}/campos — os 2
  // modelos têm o mesmo shape. RG/DataNascimentoFundacao existem na API mas o
  // form deste pedido não coleta documentoIdentidade/dataNascimento, então
  // ficam de fora (sem dado local pra preencher).
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        },
        {
          title: 'Situação Acadêmica',
          fields: [
            {
              type: 'radio',
              name: 'situacaoAcademica',
              label: 'Situação acadêmica atual',
              required: true,
              options: [
                { value: 'Bacharel', label: 'Bacharel (já concluí o curso de Direito)' },
                { value: 'Cursando', label: 'Cursando (ainda estou cursando Direito)' }
              ]
            }
          ]
        },
        {
          title: 'Dados da Instituição de Ensino',
          fields: [
            {
              type: 'text',
              name: 'ies',
              label: 'IES (Instituição de Ensino Superior)',
              required: true,
              placeholder: 'Digite o nome da sua faculdade'
            },
            {
              type: 'text',
              name: 'iesMunicipio',
              label: 'Município da IES',
              required: true,
              placeholder: 'Digite o município da IES'
            },
            {
              type: 'text',
              name: 'iesUf',
              label: 'UF da IES',
              required: true,
              placeholder: 'EX: MS, SP, RJ',
              maxLength: 2
            }
          ]
        },
        {
          title: 'Local de Realização da Prova',
          fields: [
            {
              type: 'text',
              name: 'cidadeProva',
              label: 'Cidade onde realizou a prova',
              required: true,
              placeholder: 'Digite a cidade onde fez a prova'
            },
            {
              type: 'text',
              name: 'ufProva',
              label: 'UF onde realizou a prova',
              required: true,
              placeholder: 'EX: MS, SP, RJ',
              maxLength: 2
            }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoPrimeiraViaExameDeOrdemConfig;